"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Valora = void 0;
var react_1 = __importStar(require("react"));
var react_loader_spinner_1 = __importDefault(require("react-loader-spinner"));
var AddCeloNetworkButton_1 = require("../components/AddCeloNetworkButton");
var connectors_1 = require("../connectors");
var use_contractkit_1 = require("../use-contractkit");
var Valora = function (_a) {
    var onSubmit = _a.onSubmit;
    var _b = use_contractkit_1.useContractKitInternal(), network = _b.network, initConnector = _b.initConnector, error = _b.initError, dapp = _b.dapp;
    var initialiseConnection = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var connector, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connector = new connectors_1.ValoraConnector(network, dapp.name);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, initConnector(connector)];
                case 2:
                    _a.sent();
                    onSubmit(connector);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [initConnector, network, onSubmit, dapp.name]);
    react_1.useEffect(function () {
        void initialiseConnection();
    }, [initialiseConnection]);
    if ((error === null || error === void 0 ? void 0 : error.name) === connectors_1.UnsupportedChainIdError.NAME) {
        return (react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-justify-center tw-flex-col" },
            react_1.default.createElement("p", { className: "tw-text-red-500 tw-pb-4" }, "Please connect to the Celo network to continue."),
            react_1.default.createElement(AddCeloNetworkButton_1.AddCeloNetworkButton, { chainId: network.chainId })));
    }
    return (react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-justify-center" }, error ? (react_1.default.createElement("p", { className: "tw-text-red-500 tw-pb-4" }, error.message)) : (react_1.default.createElement(react_loader_spinner_1.default, { type: "TailSpin", color: "white", height: "36px", width: "36px" }))));
};
exports.Valora = Valora;
//# sourceMappingURL=valora.js.map